import { keysToCamelCase, keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import type { Plan, PlanDTO } from './types';

export const mapPlanDtoToModel = (dto: PlanDTO): Plan => keysToCamelCase(dto);

export const mapPlanModelToDto = (model: Plan): PlanDTO => keysToSnakeCase(model);
